var bannerTextEnabledMaster = '@MC.Models.Helpers.IsFeatureEnabled("BannerText")';
var cmsBindingsDone = false;

Platform.Deferred.execute(cmsTemplateActions);
Platform.Deferred.execute(cmsTemplateLoad);
//sortable list items
$(function () {
    $('.sortableWrapper').sortable({
        items: '.sortableItems',
        handle: '.move-btn-list',
        axis: 'x,y',
        helper: 'original',
        forcePlaceHolderSize: true,
        tolerance: "pointer",
        context: this,
        update: function () {
            var order = $(this).sortable('toArray', { attribute: 'data-content-id' });
            console.log(order);
            $.ajax({
                url: root + 'Content/SaveOrderListItem',
                data: { order: order },
                type: 'post',
                traditional: true
            });
        }
    });
});
function cmsTemplateLoad()
{
    // make sure dom and elements loaded, then call to check cms functions have been setup
    $(window).load(function () {
        checkCmsInnerReady();
    });
}

function checkCmsInnerReady()
{
    if (cmsBindingsDone == false) {
        window.setTimeout(checkCmsInnerReady, 100); /* this checks the flag every 100 milliseconds*/
    } else {
        // set iFrame height based on page and call outer iFrame ready
        window.parent.setIframeHeight();
        window.parent.IframeLoaded();
    }
}

function SetCmsBindingsFlag()
{
    cmsBindingsDone = true;
}

function cmsTemplateActions()
{



    //$(function () {
    // $(window).load(function (){

        // disable adding buttons if not loading into an iframe
        if (window.location == window.parent.location) {
            return;
        }

        // if any image has height based on window need to set it here based on being inside the iframe
        h = parent.getDocumentHeight();
        $('.mbss-stretch-height').height(h - 50);

        // disable drag on all elements in this view
        $(document).on("dragstart", function () {
            return false;
        });

        // drag and drop handling
        $(".image-drop").on('dragover', function (event) {
            //console.log("dragover");
            event.preventDefault();
            var dropType = $(this).closest(".image-drop").data("drop-type");
            //console.log("dropType: " + dropType);
            if (dropType == "banner") {
                // show banner options
                $('.banner-drop-options').fadeIn();
            }
            if (dropType == "image") {
                $(this).css('opacity', '.5');
            }
            return false;
        }).on('dragleave', function (event) {
            //console.log("dragleave");
            //add preventDefault to stop default behaviour
            event.preventDefault();
            var dropType = $(this).closest(".image-drop").data("drop-type");
            if (dropType != "banner") {
                // show banner options
                $('.banner-drop-options').fadeOut();
            }
            if (dropType == "image") {
                $(this).css('opacity', '1');
            }
        });

        //Enable Drop event
        $(".image-drop").find('*').andSelf().on('drop', function (event) {
            //console.log("drop");
            event.stopPropagation();
            event.preventDefault();
            var url = event.originalEvent.dataTransfer.getData('text');
            //console.log("event.originalEvent.dataTransfer.getData: " + url);

            // set drop target url
            var dropType = $(this).closest(".image-drop").data("drop-type");
            if (dropType == "image") {
                $(this).css('opacity', '1');
                var imageDrop = $(this).closest(".image-drop");
                var pageId = imageDrop.data("page-id");
                var elementId = imageDrop.data('page-element-id');
                var width = imageDrop.data('image-width');
                var height = imageDrop.data('image-height');
                $.post(root + "/Content/UpdateImageFile?pageId=" + pageId + "&elementId=" + elementId + "&imageFile=" + url + "&width=" + width + "&height=" + height, function () {
                    reloadIframe();
                }, "json");
            }
        });

        // banner drag and drop
        $(".banner-drag").on('dragover', function (event) {
            //add preventDefault to stop default behaviour
            event.preventDefault();
            $(this).next('.banner-drop-options').fadeIn();
            return false;
        }).on('dragleave', function (event) {
            //console.log("dragleave");
            //add preventDefault to stop default behaviour
            event.preventDefault();
            var dropType = $(this).data("drop-type");
            if (dropType != "banner") {
                // show banner options
                $('.banner-drop-options').fadeOut();
            }
        });
        $(".banner-drag").on('drop', function (event) {
            event.preventDefault();
            //console.log("drop banner no action");
            //console.log($(this));
        });
        $(".banner-drop-option-zone").on('dragover', function (event) {
            //add preventDefault to stop default behaviour
            event.preventDefault();
            $(this).css('opacity', '0.9');
            return false;
        }).on('dragleave', function (event) {
            //console.log("dragleave");
            //add preventDefault to stop default behaviour
            event.preventDefault();
            $(this).css('opacity', '0.7');
        });
        $(".banner-drop-option-zone").on('drop', function (event) {
            var url = event.originalEvent.dataTransfer.getData('text');
            event.preventDefault();
            //console.log("drop banner onto action");
            //console.log($(this));
            //console.log("drop: " + $(this).data("banner-drop-action"));
            var pageId = $(this).data('page-id');
            var contentId = $(this).data('content-id');
            var elementId = $(this).data('element-id');
            var width = $(this).data('banner-width');
            var height = $(this).data('banner-height');
            var fullWidth = $(this).data('full-width');
            if ($(this).data("banner-drop-action") == "replace") {
                parent.LoadBannerEdit(pageId, contentId, elementId, url, width, height, fullWidth);
            }
            else if ($(this).data("banner-drop-action") == "new") {
                parent.LoadBannerEdit(pageId, 0, elementId, url, width, height, fullWidth);
            }
            return false;
        });

        // list item images
        $(".list-item-drop").on('dragover', function (event) {
            event.preventDefault();
            $(this).css('opacity', '.5');
            return false;
        }).on('dragleave', function (event) {
            //console.log("dragleave");
            event.preventDefault();
            $(this).css('opacity', '1');
        });
        $(".list-item-drop").on('drop', function (event) { 
            event.stopPropagation();
            event.preventDefault();
            var url = event.originalEvent.dataTransfer.getData('text');
            //console.log("event.originalEvent.dataTransfer.getData: " + url);
            $(this).css('opacity', '1');
            var pageId = $(this).closest(".mbss-listItem-wrapper").data("page-id");
            var elementId = $(this).closest(".mbss-listItem-wrapper").data('page-element-id')
            var extendedContentId = $(this).data("extended-content-id");
            $.post(root + "/Content/UpdateListItemImageFile?PageId=" + pageId + "&ExtendedContentId=" + extendedContentId + "&imageFile=" + url, function () {
                reloadIframe();
            }, "json");
        });

        $(".list-item2-drop").on('dragover', function (event) {
            event.preventDefault();
            $(this).css('opacity', '.5');
            return false;
        }).on('dragleave', function (event) {
            //console.log("dragleave");
            event.preventDefault();
            $(this).css('opacity', '1');
        });
        $(".list-item2-drop").on('drop', function (event) {
            event.stopPropagation();
            event.preventDefault();
            var url = event.originalEvent.dataTransfer.getData('text');
            //console.log("event.originalEvent.dataTransfer.getData: " + url);
            $(this).css('opacity', '1');
            var pageId = $(this).data("page-id");
            var elementId = $(this).data('page-element-id')
            var contentId = $(this).data('content-id')
            var extendedContentId = $(this).data("extended-content-id");
            var itemNum = $(this).data("item-num");
            var listItemNum = $(this).data("list-item-num");
            $.post(root + "/Content/UpdateListItem2ImageFile", { PageId: pageId, contentId: contentId, ExtendedContentId: extendedContentId, imageFile: url, itemNum: itemNum, listItemNum: listItemNum }, function () {
                reloadIframe();
            }, "json");
        });

        /********* TEXT AREAS ***********/
        var colorsAdditional = $('body').data('custom-colours') !== '' ? $('body').data('custom-colours').split(',') : null;
        var fontColors = ['#000000', '#ffffff'];
        if ($.isArray(colorsAdditional) && colorsAdditional.length > 0)
            fontColors = fontColors.concat(colorsAdditional);

        // find text areas and add edit buttons for them
        $('.mbss-text .mbss-content').each(function () {
            var holder = $(this).parents('.mbss-text');
            if (holder.data("text-item-type") == "banner")
            {
                console.log("edit text banner");
                $(this).redactor({
                    buttons: ['format', 'bold', 'italic', 'underline', 'deleted', 'lists', 'link'],
                    plugins: ['source', 'table', 'fontcolor', 'alignment'],
                    linebreaks: true,
                    pastePlainText: true,
                    removeEmpty: ['a'],
                    //toolbarFixed: true,
                    //toolbarFixedTarget: '.redactor-box',
                    paragraphize: false,
                    script: false,
                    //formatting: ['p', 'h1', 'h2', 'h3', 'h4'],
                    formatting: ['p'],
                    formattingAdd: {
                        'banner-text-large': {
                            title: 'Banner Text Large',
                            args: ['div', 'class', 'banner-text-large']
                        },
                        'banner-text-medium': {
                            title: 'Banner Text Medium',
                            args: ['div', 'class', 'banner-text-medium']
                        },
                        'banner-text-small': {
                            title: 'Banner Text Small',
                            args: ['div', 'class', 'banner-text-small']
                        }
                    },
                    placeholder: 'Enter Text...',
                    fontColorsOverride: fontColors
                });
                $(this).addClass('mbss-hover-highlight');
                holder.addClass('redactor-in');
            }
            else
            {
                console.log("edit text normal");
                $(this).redactor({
                    buttons: ['format', 'bold', 'italic', 'underline', 'deleted', 'lists', 'link'],
                    plugins: ['source', 'table', 'fontcolor', 'alignment', 'video'],
                    linebreaks: true,
                    pastePlainText: true,
                    removeEmpty: ['a'],
                    //toolbarFixed: true,
                    //toolbarFixedTarget: '.redactor-box',
                    paragraphize: false,
                    script: false,
                    formatting: ['p', 'h1', 'h2', 'h3', 'h4'],
                    placeholder: 'Enter Text...',
                    fontColorsOverride: fontColors
                });
                holder.addClass('mbss-hover-highlight');
                holder.addClass('redactor-in');
            }
            //$("<button class='btn btn-default btn-xs btn-custom mbss-edit-btn editTxtBtn' data-element-id='" + $(this).data('element-id') + "' data-page-content-id='" + $(this).data('page-content-id') + "' data-page-id='" + $(this).data("page-id") + "'>Edit Text</button>").appendTo($(this));
            
            $(this).click(function () {
                var holder = $(this).parents('.mbss-text');
                var textHolder = holder.find('.mbss-content');
                if (!holder.hasClass('mbss-editmode')) {
                    textHolder.data('old-content', textHolder.redactor('code.get'));
                    $(this).parent().find('.redactor-toolbar').show();
                    holder.addClass('mbss-editmode');
                    holder.find('.mbss-textArea-btns').show();
                    //holder.find('.mbss-saveTxtBtn').addClass('mbss-buttonShow');
                    //holder.find('.mbss-cancelTxtBtn').addClass('mbss-buttonShow');
                    // show/hide buttons while text editing
                    $('.hide-for-text-editor').css('visibility', 'hidden');
                    if (holder.data('text-item-type') === 'banner') {
                        // hide the banner buttons
                        $('.banner-btn').css('visibility', 'hidden');
                    }
                }
            });
        });

        $('.mbss-saveTxtBtn').click(function (e) {
            e.preventDefault();
            parent.showLoading();
            var holder = $(this).parents('.mbss-text');
            var pageContentId = holder.data('page-content-id');
            var pageId = holder.data('page-id');
            var elementId = holder.data('element-id');
            var extendedContentId = holder.data('extended-content-id');
            var textHolder = holder.find('.mbss-content');
            var content = textHolder.redactor('code.get');
            var textItemType = holder.data('text-item-type');
            var itemNum = holder.data('item-num');
            //console.log(content);
            $.post(root + '/Content/SaveText', { content: content, pageContentId: pageContentId, pageId: pageId, elementId: elementId, extendedContentId: extendedContentId, textItemType: textItemType, itemNum: itemNum }, function (data) {
                if (data.result == "ok") {
                    // set the contentid and extendedContentId if we are getting a valid value back (not 0)
                    if (data.newExtendedId != "0") {
                        holder.data('extended-content-id', data.newExtendedId);
                    }
                    else if (data.newContentId != "0") {
                        holder.data('page-content-id', data.newContentId);
                    }

                    // Ensure not in HTML mode
                    if (!textHolder.is(':visible'))
                        textHolder.redactor('source.hide');

                    holder.find('.redactor-toolbar').hide();
                    holder.removeClass('mbss-editmode');
                    holder.find('.mbss-textArea-btns').hide();
                    //holder.find('.mbss-saveTxtBtn').removeClass('mbss-buttonShow');
                    //holder.find('.mbss-cancelTxtBtn').removeClass('mbss-buttonShow');
                    parent.hideLoading();
                    
                    // show/hide buttons while text editing
                    $('.hide-for-text-editor').css('visibility', 'visible');
                    if (holder.data('text-item-type') === 'banner') {
                        // show the banner buttons
                        $('.banner-btn').css('visibility', 'visible');
                    }
                    $.fn.matchHeight._update(); // call match height plugin update
                }
                else {
                    parent.hideLoading();
                    alert("Error saving content");
                }
            }, "json");

        });
        $('.mbss-cancelTxtBtn').click(function (e) {
            e.preventDefault();
            var holder = $(this).parents('.mbss-text');
            var textHolder = holder.find('.mbss-content');            

            // Ensure not in HTML mode
            if (!textHolder.is(':visible'))
                textHolder.redactor('source.hide');

            textHolder.redactor('code.set', textHolder.data('old-content'));
            holder.find('.redactor-toolbar').hide();
            holder.removeClass('mbss-editmode');
            holder.find('.mbss-textArea-btns').hide();
            //holder.find('.mbss-saveTxtBtn').removeClass('mbss-buttonShow');
            //holder.find('.mbss-cancelTxtBtn').removeClass('mbss-buttonShow');
            
            // show/hide buttons while text editing
            $('.hide-for-text-editor').css('visibility', 'visible');
            if (holder.data('text-item-type') == "banner") {
                // show the banner buttons
                $('.banner-btn').css('visibility', 'visible');
            }
        });

        // !handle click of text edit button is in content page
        /********* MAIN BANNERS ***********/
        // find main banners and add edit buttons for them
        $('.mbss-banner-item').each(function () {
            var contentId = $(this).data('content-id');
            var pageId = $(this).data('page-id');
            var elementId = $(this).data('element-id');
            var itemNum = $(this).data('item-num');
            var width = $(this).data('banner-width');
            var height = $(this).data('banner-height');
            var fullWidth = $(this).data('full-width');
            var videoBanner = $(this).data('video-banner');
            $("<button class='btn btn-xs btn-custom banner-btn editMainbanner' data-page-id='" + pageId + "' data-content-id='" + contentId + "' data-element-id='" + elementId + "' data-banner-width='" + width + "' data-banner-height='" + height + "' data-full-width='" + fullWidth + "' data-video-banner='" + videoBanner + "'>Edit Banner <span class='glyphicon glyphicon-picture'></i></button>").appendTo($(this));
            $("<button class='btn btn-xs btn-custom banner-btn delete-main-banner' data-content-id='" + contentId + "' data-item-num='" + itemNum + "'>Delete Banner <span class='glyphicon glyphicon-th-list glyphicon glyphicon-trash'></i></button>").appendTo($(this));
            $("<button class='btn btn-xs btn-custom banner-btn editMainbanner add-main-banner' data-page-id='" + pageId + "' data-content-id='" + "0" + "' data-element-id='" + elementId + "' data-banner-width='" + width + "' data-banner-height='" + height + "' data-full-width='" + fullWidth + "' data-video-banner='" + videoBanner + "'>Add New Banner <span class='glyphicon glyphicon-plus'></span></button>").appendTo($(this));
            $("<button class='btn btn-xs btn-custom banner-btn manage-main-banners' data-element-id='" + elementId + "' data-content-id='" + contentId + "' data-page-id='" + pageId + "'>Manage Banners <span class='glyphicon glyphicon-th-list'></span></button>").appendTo($(this));
            if (bannerTextEnabledMaster == 'True') {
                if ($(this).data('has-banner-text') == 'True') {
                    $("<button class='btn btn-xs btn-custom  banner-btn edit-banner-text' data-page-id='" + pageId + "' data-content-id='" + contentId + "'>Edit Text <span class='glyphicon glyphicon-edit'></span></button>").appendTo($(this));
                }
            }
        });
        // handle click of main banner edit button in content page (where modals reside)

        $('.edit-banner-layer').click(function () {
            var contentId = $(this).data('content-id');
            var layerId = $(this).data('banner-layer-id');
            $('#bannerLayerEditPane').load(root + "/Content/GetBannerLayer", { pPageId: pageId, pContentId: contentId, pLayerId: layerId });
            $('#bannerLayerModel').modal('show');
        });


        /********* IMAGES ***********/
        // find images and add edit buttons for them
        $('.mbss-image').each(function () {
            $("<button class='btn btn-default btn-xs btn-custom editImage mbss-edit-btn' data-page-element-id='" + $(this).data('page-element-id') + "' data-page-content-id='" + $(this).data('page-content-id') + "' data-page-id='" + $(this).data("page-id") + "' data-image-width='" + $(this).data("image-width") + "' data-image-height='" + $(this).data("image-height") + "'>Edit Image</button>").appendTo($(this));
            if ($(this).data('is-cropped') == "False" && $(this).data('image-width') != "0" && $(this).data('image-height') != "0") {
                $("<a href='#' class='image-needs-croppping tip' data-toggle='tooltip' data-placement='right' title='This image should be cropped to fit the layout properly, click to edit and to crop it.'></a>").appendTo($(this));
            }
        });
        //$('.tip').tooltip();
        // !handle click of image edit button in content page



        /********* LIST ITEMS ***********/
        $('.mbss-listItem-wrapper').each(function () {
            $("<button class='btn btn-default btn-xs btn-custom addListItemTxtBtn' data-page-id='" + $(this).data('page-id') + "' data-element-id='" + $(this).data('element-id') + "' data-fixed-layout='" + $(this).data('fixed-layout') + "' data-num-images='" + $(this).data('num-images') + "' data-num-text='" + $(this).data('num-text') + "'>Add Repeating Item <span class=\"glyphicon glyphicon-plus\"></span></button>").appendTo($(this));
        });
        

        $('.addListItemTxtBtn').click(function (evt) {
            evt.preventDefault();
            var pageId = $(this).data('page-id');
            var elementId = $(this).data('element-id');
            var fixedLayout = $(this).data('fixed-layout');
            var numImages = $(this).data('num-images');
            var numText = $(this).data('num-text');
            $.post(root + "/Content/AddListItem", { pPageId: pageId, pElementId: elementId, pFixedLayout: fixedLayout, pNumImages: numImages, pNumText: numText }, function () {
                reloadIframe();
            }, "json");
        });

        // edit list item button
        $('.mbss-listItem').each(function () {
            var fixedLayout = $(this).data("fixed-layout");
            if (fixedLayout == true) {
                $("<a class=\"move-btn move-btn-2\" href=\"#\" data-content-id=\"" + $(this).data("content-id") + "\"><span class=\"icon-move\"></span></a><a href=\"#\" class=\"btn btn-default btn-xs btn-custom deleteListItemBtn fixedDeletListItemBtn\" data-content-id=\"" + $(this).data("content-id") + "\">Delete Item</a>").appendTo($(this));
            }
            else {
                $("<a class=\"move-btn move-btn-2\" href=\"#\" data-content-id=\"" + $(this).data("content-id") + "\"><span class=\"icon-move\"></span></a><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" data-toggle=\"dropdown\">Edit Item <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a href=\"#\" class=\"list-item-add-text\" data-content-id=\"" + $(this).data("content-id") + "\">Add Text</a></li><li><a href=\"#\" class=\"list-item-add-image\" data-content-id=\"" + $(this).data("content-id") + "\">Add Image</a></li><li><a href=\"#\" class=\"deleteListItemBtn\" data-content-id=\"" + $(this).data("content-id") + "\">Delete Item</a></li><li><a href=\"#\" class=\"copyListItemBtn\" data-content-id=\"" + $(this).data("content-id") + "\">Copy Item Layout</a></li></ul></div>").appendTo($(this));
            }
        });       

        $('.list-item-add-text').click(function () {
            var contentId = $(this).data("content-id");
            $.post(root + "/Content/AddTextToListItem", { pContentId: contentId }, function () {
                reloadIframe();
            }, "json");
        });

        $('.list-item-add-image').click(function () {
            var contentId = $(this).data("content-id");
            $.post(root + "/Content/AddImageToListItem", { pContentId: contentId }, function () {
                reloadIframe();
            }, "json");
        });

        //$('.mbss-listItem').each(function () {
        //    $("<button class='btn btn-default btn-xs deleteListItemBtn' data-page-id='" + $(this).data('page-id') + "' data-element-id='" + $(this).data('element-id') + "'data-item-num='" + $(this).data('item-num') + "'>Delete Item</button>").appendTo($(this).find('.list-item-actions'));
        //});
        $('.deleteListItemBtn').click(function () {
            if (confirm("Confirm delete?")) {
                var contentID = $(this).data('content-id');
                $.post(root + "/Content/DeleteListItem", { pContentId: contentID }, function () {
                    reloadIframe();
                }, "json");
            }
            return false;
        });

        //$('.mbss-listItem-text').each(function () {
        //    $("<button class=\"btn btn-default btn-xs btn-custom editListItemTxtBtn\" data-page-id=\"" + @ViewBag.PageId + "\" data-extended-content-id=\"" + $(this).data("extended-content-id") + "\">Edit Text</button>").appendTo($(this));
        //});

        // list item text button handlers in content page

                $('.mbss-listItem-image').each(function () {
                    $("<button class='btn btn-default btn-xs btn-custom editListItemImageBtn' data-page-id='" + pageId + "' data-extended-content-id='" + $(this).data('extended-content-id') + "'data-item-num='" + $(this).data('item-num') + "' data-image-width='" + $(this).data("image-width") + "' data-image-height='" + $(this).data("image-height") + "'>Edit Image</button>").appendTo($(this));
                });
        // list item image button handlers in content page

        $('.copyListItemBtn').click(function (e) {
            e.preventDefault();
            var contentID = $(this).data('content-id');
            $.post(root + "/Content/CopyListItem", { pContentId: contentID }, function () {
                reloadIframe();
            }, "json");
        });

        // new list items
        $('.mbss-listItem2-wrapper').each(function () {
            $(this).addClass("mbss-hover-highlight");
            $("<button class='btn btn-default btn-xs btn-custom addListItem2Btn' data-page-id='" + $(this).data('page-id') + "' data-element-id='" + $(this).data('element-id') + "'>Add Item <span class=\"glyphicon glyphicon-plus\"></span></button>").appendTo($(this));
        });
        $('.addListItem2Btn').click(function (evt) {
            evt.preventDefault();
            var pageId = $(this).data('page-id');
            var elementId = $(this).data('element-id');
            $.post(root + "/Content/AddListItem2", { pPageId: pageId, pElementId: elementId }, function () {
                reloadIframe();
            }, "json");
        });

        $('.mbss-listItem2').each(function () {
            $(this).addClass("mbss-hover-highlight");
            $("<button class='btn btn-default btn-xs btn-custom hide-for-text-editor deleteListItem2Btn' data-content-id='" + $(this).data('content-id') + "'>Delete Item <span class=\"glyphicon glyphicon-cross\"></span></button>").appendTo($(this));
        });
        $('.deleteListItem2Btn').click(function () {
            if (confirm("Confirm delete?")) {
                var contentID = $(this).data('content-id');
                $.post(root + "/Content/DeleteListItem", { pContentId: contentID }, function () {
                    reloadIframe();
                }, "json");
            }
            return false;
        });
        $('.mbss-listItem2-image-wrapper').each(function () {
            $(this).addClass("mbss-hover-highlight");
            $("<button class='btn btn-default btn-xs btn-custom editListItem2ImageBtn' data-content-id='" + $(this).data('content-id') + "' data-page-id='" + pageId + "' data-extended-content-id='" + $(this).data('extended-content-id') + "'data-item-num='" + $(this).data('item-num') + "' data-image-width='" + $(this).data("image-width") + "' data-image-height='" + $(this).data("image-height") + "'>Edit Image</button>").appendTo($(this));
        });
    $('.mbss-listItem2-image-wrapper').each(function () {
        $(this).addClass("mbss-hover-highlight");
        $("<button class='btn btn-default btn-xs btn-custom editListItem2ImageBtn' data-content-id='" + $(this).data('content-id') + "' data-page-id='" + pageId + "' data-extended-content-id='" + $(this).data('extended-content-id') + "'data-item-num='" + $(this).data('item-num') + "' data-image-width='" + $(this).data("image-width") + "' data-image-height='" + $(this).data("image-height") + "'>Edit Image</button>").appendTo($(this));
    });
    $('.mbss-list-item-sortable').each(function () {
        $("<a href='#' class='move-btn-list' data-id='" + $(this).data('content-id') + "'><i class='fas fa-arrows'></i></a>").prependTo($(this));
    });
    /********* FLIP IMAGES ***********/
    // find flip images and add edit buttons for them
    $('.mbss-flip-item').each(function () {
        var contentId = $(this).data('content-id');
        var pageId = $(this).data('page-id');
        var elementId = $(this).data('element-id');
        var itemNum = $(this).data('item-num');
        var width = $(this).data('flip-image-width');
        var height = $(this).data('flip-image-height');
        var fullWidth = $(this).data('full-width');
        $("<button class='btn btn-xs btn-custom flip-image-btn manage-flip-images' data-element-id='" + elementId + "' data-content-id='" + contentId + "' data-page-id='" + pageId + "' data-width='" + width + "' data-height='" + height + "'>Manage Flip Images<span class='glyphicon glyphicon-th-list'></span></button>").appendTo($(this));
    });
        /********* PDF Files ***********/
        // find images and add edit buttons for them
        $('.mbss-pdffile-wrapper').each(function () {
            $("<button class='btn btn-default btn-sm editPdfFile' data-element-id='" + $(this).data('element-id') + "' data-content-id='" + $(this).data('content-id') + "' data-page-id='" + $(this).data('page-id') + "'>Edit PDF File <i class='icon-list-alt'></i></button>").appendTo($(this));
        });

        // TEXT FADER
        // add buttons
        $('.mbss-text-fader-wrapper').each(function () {
            $("<button class='btn btn-default btn-xs btn-custom mbss-edit-btn editTxtFaderBtn' data-element-id='" + $(this).data('element-id') + "' data-content-id='" + $(this).data('content-id') + "' data-page-id='" + $(this).data("page-id") + "'>Edit Text Fader</button>").appendTo($(this));
        });

        // EMAIL FORMS
        // add button
        $('.mbss-emailForm-wrapper').each(function () {
            $('<button type="button" class="btn btn-default btn-xs btn-custom mbss-edit-btn mbss-edit-btn-emailForm" data-page-id="' + $(this).data('page-id') + '" data-element-id="' + $(this).data('element-id') + '">Edit Email Form</button>').appendTo($(this));
        });
        //SUBSCRIBE
        $('.mbss-subscribe-wrapper').each(function () {
            $('<button type="button" class="btn btn-default btn-xs btn-custom mbss-edit-btn mbss-edit-btn-subscribe" data-page-id="' + $(this).data('page-id') + '" data-element-id="' + $(this).data('element-id') + '">Edit Subscribe Form</button>').appendTo($(this));
        });

        // REPEATER
        $('.mbss-repeater-wrapper').each(function () {
            $("<button class='btn btn-default btn-xs btn-custom mbss-edit-btn mbss-repeater-item-add-new-text-btn' data-element-id='" + $(this).data('element-id') + "' data-content-id='" + $(this).data('content-id') + "' data-page-id='" + $(this).data("page-id") + "' data-extended-content-id=\"0\"'>Add New Text Item</button>").appendTo($(this));
            $("<button class='btn btn-default btn-xs btn-custom mbss-edit-btn mbss-repeater-item-add-new-image-btn' data-element-id='" + $(this).data('element-id') + "' data-content-id='" + $(this).data('content-id') + "' data-page-id='" + $(this).data("page-id") + "' data-extended-content-id=\"0\"'>Add New Image Item</button>").appendTo($(this));
        });

        //$('.mbss-repeater-item-text').each(function () {
        //    $("<button class='btn btn-default btn-xs btn-custom mbss-edit-btn mbss-repeater-item-edit-text-btn' data-extended-content-id='" + $(this).data("extended-content-id") + "'>Edit Text</button>").appendTo($(this));
        //    $("<button class='btn btn-default btn-xs btn-custom mbss-edit-btn mbss-repeater-item-delete-item-btn' data-extended-content-id='" + $(this).data("extended-content-id") + "'>Delete Text Item</button>").appendTo($(this));
        //});
        $('.mbss-repeater-item-image').each(function () {
            $("<button class='btn btn-default btn-xs btn-custom mbss-edit-btn mbss-repeater-item-edit-image-btn' data-extended-content-id='" + $(this).data("extended-content-id") + "' data-image-width='" + $(this).data("image-width") + "' data-image-height='" + $(this).data("image-height") + "'>Edit Image</button>").appendTo($(this));
            $("<button class='btn btn-default btn-xs btn-custom mbss-edit-btn mbss-repeater-item-delete-item-btn' data-extended-content-id='" + $(this).data("extended-content-id") + "'>Delete Image Item</button>").appendTo($(this));
        });
        $(".repeater-image-drop").on('dragover', function (event) {
            event.preventDefault();
            $(this).css('opacity', '.5');
            return false;
        }).on('dragleave', function (event) {
            event.preventDefault();
            $(this).css('opacity', '1');
        });
        $(".repeater-image-drop").on('drop', function (event) {
            event.stopPropagation();
            event.preventDefault();
            var url = event.originalEvent.dataTransfer.getData('text');
            //console.log("event.originalEvent.dataTransfer.getData: " + url);
            $(this).css('opacity', '1');
            var extendedContentId = $(this).data("extended-content-id");
            $.post(root + "/Content/UpdateRepeaterItemImageFile", { extendedContentId: extendedContentId, imageFile: url }, function () {
                reloadIframe();
            }, "json");
        });
        //SECTION BACKGROUND COLOR
    $('[data-cms-bg-color]').each(function () {
        $("<input class='form-control mbss-cms-bg-color' type='text' data-page-id='" + $(this).data('page-id') + "' data-content-id='" + $(this).data('page-content-id') + "' data-element-id='" + $(this).data('element-id') +"'>").appendTo($(this));
    });

        // new image widget (images and bg images)
        $('.mbss-image-x').each(function () {
            var containerClass = "mbss-image-x-" + $(this).data("page-id") + "-" + $(this).data('element-id');
            var buttonClass = "mbss-image-x-btn-" + $(this).data("page-id") + "-" + $(this).data('element-id');
            var imageType = $(this).data("image-type");
            var btn;


            // create button with unique class and append to this element
            if (imageType == "image") {
                // add wrapper (cant put button inside of the image) with the container class
                $($(this)).wrap("<div class='mbss-image-x-wrap " + containerClass + "' style='position:relative'></div>");
                // add button
                btn = $($(this)).after("<button class='btn btn-default btn-xs btn-custom editImageX mbss-edit-btn " + buttonClass + " style='postion:absolute;top:0;left:0'" +
                    "' data-element-id='" + $(this).data('element-id') +
                    "' data-content-id='" + $(this).data('content-id') +
                    "' data-page-id='" + $(this).data('page-id') +
                    "' data-image-width='" + $(this).data('image-width') +
                    "' data-image-height='" + $(this).data('image-height') +
                    "' data-full-width='" + $(this).data('full-width') +
                    "'><i class='far fa-image'></i> Edit Image</button>");
            }
            else if (imageType == "bgimage") {
                // add unique class to the container
                $(this).addClass(containerClass);
                // add button
                btn = $("<button class='btn btn-default btn-xs btn-custom editImageX mbss-edit-btn " + buttonClass +
                    "' data-element-id='" + $(this).data('element-id') +
                    "' data-content-id='" + $(this).data('content-id') +
                    "' data-page-id='" + $(this).data('page-id') +
                    "' data-image-width='" + $(this).data('image-width') +
                    "' data-image-height='" + $(this).data('image-height') +
                    "' data-full-width='" + $(this).data('full-width') +
                    "'><i class='far fa-image'></i> Edit Image</button>").appendTo($(this));
                // use jquery UI to position the button
                $(btn).position({
                    my: "left top",
                    at: "left top",
                    of: $(this)
                });
            }

            // add function to show button on hover
            $('.' + containerClass).hover(function () {
                $('.' + buttonClass).addClass("btn-show");
            }, function () {
                $('.' + buttonClass).removeClass("btn-show");
            });

        });

        // nwe image widget drag and drop handler
        $(".mbss-image-x").on('dragover', function (event) {
            event.preventDefault();
            $(this).css('opacity', '.5');           
            return false;
        }).on('dragleave', function (event) {
            event.preventDefault();
            $(this).css('opacity', '1');
        });
        $(".mbss-image-x").on('drop', function (event) {
            event.stopPropagation();
            event.preventDefault();
            var url = event.originalEvent.dataTransfer.getData('text');
            $(this).css('opacity', '1');
            var imageDrop = $(this);
            var pageId = imageDrop.data("page-id");
            var elementId = imageDrop.data('element-id');
            var width = imageDrop.data('image-width');
            var height = imageDrop.data('image-height');
            $.post(root + "/Content/UpdateImageFile", { pageId: pageId, elementId: elementId, imageFile: url, width: width, height: height }, function () {
                reloadIframe();
            }, "json");
            
        });

    //});

    function reloadIframe() {
        $('#frame-modal', window.parent.document).addClass("show");
        location.reload();
    }

    // all bindings done    
    SetCmsBindingsFlag();
}